import { z } from 'zod';

/** Money primitive shared across the rich cards (offers, quote, reservation,
 *  confirmation summary, rental, booking summary). */
export const ChatUiMoneySchema = z.object({
  amount: z.number(),
  currency: z.string().min(1),
});
export type ChatUiMoney = z.infer<typeof ChatUiMoneySchema>;
